module.exports = __webpack_public_path__ + "assets/img/dzfp.3fc8fab7.jpg";